import { useEffect, useContext, useRef } from 'react'
import { getApod } from "../context/nasa/NasaActions"
import NasaContext from '../context/nasa/NasaContext'
import Spinner from './layout/Spinner'

function Apod() {
  const {loading, apod, dispatch} = useContext(NasaContext)
  const loaded = useRef(false)
  useEffect(() => {
    dispatch({type: 'SET_LOADING'})
    const getApodData = async() => {
      const apodData = await getApod()
      loaded.current = true;
      dispatch({type: 'SET_APOD', payload: apodData})
    }
    getApodData()
  }, [dispatch])

  const {
    title,
    url,
    explanation,
  } = apod

  if (!loaded.current || loading) { return <Spinner /> }
  return (
    <div>
      <h2>{title}</h2>
      <img src={url} className='apod' alt='apod'/>
      <p>{explanation}</p>
    </div>
  )
}

export default Apod
